import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from '@cradua/material';
import { DashboardNavComponent } from './dashboard-nav/dashboard-nav.component';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    AngularMaterialModule,
  
  ],
  declarations: [DashboardNavComponent],
  exports: [DashboardNavComponent],
})
export class EpimsDashboardNavModule {}
